import React, { useEffect, useState } from "react";
import { useConfig } from "providers/ConfigProvider";
import useFetchApi from "hooks/useFetchApi";

const Simulateur = () => {
  const [fetchApi] = useFetchApi();
  const { simulatorUrl } = useConfig();
  const [embeddedUrl, setEmbeddedUrl] = useState(null);

  useEffect(() => {
    fetchApi("sso/token", { method: "GET" })
      .then(({ token }) => {
        setEmbeddedUrl(`${simulatorUrl}/?token=${token}`);
      })
      .catch(() => {
        setEmbeddedUrl(`${simulatorUrl}/`);
      });
  }, [fetchApi, simulatorUrl]);

  if (!embeddedUrl) return null;

  return (
    <div className="text-sm mt-4 h-full flex">
      <iframe
        title="Embedded Simulations"
        src={embeddedUrl}
        className="md:rounded-xl md:border-0.5 border-stone-400 w-full md:h-[700px]  !overflow-hidden"
      />
    </div>
  );
};

export default Simulateur;
